import React, {Component} from 'react';
import {permissionCheck} from "../../../../utils";
import {Button, Menu, Dropdown, Icon} from "antd";
import {contentParser} from "../../../../base/BaseComponent";

class NormalOperation extends Component {
    render() {
        let {tableComponent, record} = this.props;
        let btns = tableComponent.parseListBtn(record);

        let btnDomList = [];
        btns.forEach((item, index) => {
            if(item.auth){//校验当前用户是否有对应权限，如果有才能看到
                let auth = item.auth;
                if(!permissionCheck(auth)){
                    return;
                }
            }
            // 需要执行的内容
            const executing = item => {
                btnDomList.push(<span  style={{marginRight:'10px',color: window.sysConfig && window.sysConfig.getValueByKey("newSecondSelectColor", '#0050B3')||'#0050B3',cursor:'pointer'}} key={index} onClick={() => {
                    tableComponent.setState({version: record.version});
                    if(!item.clickParams){
                        item.onOk(record.id, item.name)
                    }else{
                        record.self = {...record};
                        let newClickParams = [...item.clickParams];
                        contentParser(newClickParams, {record});
                        contentParser(newClickParams, {item});
                        if(item.newTimeCheck){
                            item.onOk(...newClickParams,item,record);
                        }else{
                            item.onOk(...newClickParams);
                        }


                    }
                }}>{item.name}</span>)
            }
            // 对是否存在conditionFun判断
            const conditionFunToExecute = (item,isExecuteFn,notExecuteFn) => {
                if (item.conditionFun) {
                    try {
                        let funParams = {conditionFun:item.conditionFun}
                        contentParser(funParams, {record,window: window,that:this,});
                        let fn = eval(funParams.conditionFun);
                        if(fn()){
                            isExecuteFn();
                        }
                    } catch(e) {
                        console.log(e.toString())
                    }
                }else if(notExecuteFn) {
                    notExecuteFn(item);
                }
            }
            if (Array.isArray(item.condition) && item.condition.indexOf(record.status) !== -1) {
                conditionFunToExecute(item,()=>executing(item),()=>executing(item));
            }else if(!Array.isArray(item.condition)){
                conditionFunToExecute(item,()=>executing(item));
            }
            
        });
        return (
            <div>
                {
                    btnDomList&&(btnDomList.length > 0)?(
                        btnDomList.map((btn,index)=>{
                            if(index<3) {
                                return btn
                            }
                            if(index===3) {
                                let menus = btnDomList.slice(3,btnDomList.length);
                                menus= (
                                    <Menu>
                                        {
                                            menus.map((menu,Index)=>(
                                                <Menu.Item key={Index}>
                                                    {menu}
                                                </Menu.Item>
                                            ))
                                        }
                                    </Menu>
                                );
                                return (
                                    <Dropdown overlay={menus} placement="bottomLeft" key={index}>
                                        <Icon type="ellipsis" />
                                    </Dropdown>
                                )
                            }
                        })
                    ):"-"
                }
            </div>
        )
    }
}

export default NormalOperation;
